import React from 'react';
import { Check, Clock, AlertTriangle, X, CreditCard } from 'lucide-react';
import { formatDateTime, formatRelativeTime } from '../../utils/formatRelativeTime';

function buildEvents(payment) {
  if (!payment) return [];
  const now = new Date();
  const dueDate = payment.dueDate ? new Date(payment.dueDate) : null;
  const isPaid = ['confirmed', 'paid', 'received'].includes(payment.status);
  const isOverdue = !isPaid && dueDate && dueDate < now;

  const events = [
    {
      key: 'created',
      label: 'Cobrança gerada',
      at: payment.createdAt,
      icon: CreditCard,
    },
  ];

  if (dueDate) {
    events.push({
      key: 'due',
      label: isOverdue ? 'Venceu' : 'Vence',
      at: dueDate,
      icon: isOverdue ? AlertTriangle : Clock,
      variant: isOverdue ? 'error' : 'pending',
    });
  }

  if (payment.paidAt || isPaid) {
    events.push({
      key: 'paid',
      label: 'Pagamento confirmado',
      at: payment.paidAt,
      icon: Check,
      variant: 'success',
    });
  }

  if (payment.status === 'failed' || payment.status === 'cancelled' || payment.status === 'refunded') {
    events.push({
      key: 'terminal',
      label:
        payment.status === 'refunded'
          ? 'Estornado'
          : payment.status === 'cancelled'
          ? 'Cancelado'
          : 'Falhou',
      at: payment.updatedAt || payment.createdAt,
      icon: X,
      variant: 'error',
    });
  }

  return events;
}

const VARIANT_STYLES = {
  default: 'bg-primary text-white',
  success: 'bg-success text-white',
  error: 'bg-error text-white',
  pending: 'bg-app-surface-hover text-app-text-secondary',
};

const PaymentTimeline = ({ payment, className = '' }) => {
  const events = buildEvents(payment);
  if (!events.length) return null;

  return (
    <ol className={`relative border-l-2 border-app-border pl-6 space-y-6 ${className}`}>
      {events.map((ev) => {
        const Icon = ev.icon;
        const styleKey = ev.variant || 'default';
        return (
          <li key={ev.key} className="relative">
            <span
              className={`absolute -left-[2.1rem] top-0 w-8 h-8 rounded-full flex items-center justify-center ring-4 ring-white ${VARIANT_STYLES[styleKey]}`}
            >
              <Icon size={16} />
            </span>
            <div>
              <p className={`text-sm font-medium ${styleKey === 'pending' ? 'text-app-text-secondary' : 'text-app-text'}`}>
                {ev.label}
              </p>
              {ev.at && (
                <p className="text-xs text-app-text-secondary mt-0.5">
                  {formatRelativeTime(ev.at)} · {formatDateTime(ev.at)}
                </p>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default PaymentTimeline;
